module.exports = __webpack_public_path__ + "img/shipo-icon-danger.2056930d.svg";